import { faArrowDownShortWide, faLocationDot, faStar, faWallet, IconDefinition } from '@fortawesome/pro-light-svg-icons';

import { SearchType } from '@/types/most-search-type';

export enum SearchSortType {
  RELEVANCE = 'all',
  DISTANCE = 'distance',
  PRICE = 'price',
  RATING = 'rating',
}

export interface SearchSortOptionProps {
  name: string;
  icon: IconDefinition;
}

export const SearchSortMap: Record<SearchSortType, SearchSortOptionProps> = {
  [SearchSortType.RELEVANCE]: {
    name: 'Mais relevantes',
    icon: faArrowDownShortWide,
  },
  [SearchSortType.DISTANCE]: {
    name: 'Mais próximos',
    icon: faLocationDot,
  },
  [SearchSortType.PRICE]: {
    name: 'Menor preço',
    icon: faWallet,
  },
  [SearchSortType.RATING]: {
    name: 'Melhor avaliado',
    icon: faStar,
  },
};

export const searchSortOptions: SearchSortType[] = [
  SearchSortType.RELEVANCE,
  SearchSortType.DISTANCE,
  SearchSortType.PRICE,
  SearchSortType.RATING,
];

export const DISTANCE_ANALYTICS_KEY = 'distancia';

export const SearchSortAnalyticsMap: Record<SearchSortType, string> = {
  [SearchSortType.RELEVANCE]: 'relevancia',
  [SearchSortType.DISTANCE]: DISTANCE_ANALYTICS_KEY,
  [SearchSortType.PRICE]: 'preco',
  [SearchSortType.RATING]: 'avaliacao',
};

export const SearchModalityAnalyticsMap: Partial<Record<SearchType, string>> = {
  [SearchType.ONLINE_CONSULTATION]: 'teleconsulta',
  [SearchType.PRESENTIAL_CONSULTATION]: 'presencial',
  [SearchType.LABORATORIAL_EXAM]: 'exame_laboratorial',
  [SearchType.VACCINE]: 'vacina',
};
